import React, { useState } from 'react'
import Button from 'Lib/Buttons'
import PageLoader from 'Lib/Pageloader'

import { RowItem } from '..'
import { formatDateTime, httpAxios, fireClevertapEvent } from 'AccountsUtils'
import { CASE_HISTORY_MODAL_DETAIL, POST_CALL } from 'AccountsConstants/api_endpoints'
import RaiseComplaintAction from './RaiseComplaintAction'
import RaiseComplaintActionDesktop from './RaiseComplaintActionDesktop'

const CaseInfo = props => {
  const { title, status, statusCode, isPWA } = props
  return (
    <React.Fragment>
      <section className={`bg-white  ${isPWA ? 'p-4 border-bottom-grey' : 'px-8'} flex flex-column`}>
        <div className={`flex flex-top ${isPWA ? '' : 'pt-2'}`}>
          <div className="flex-1">
            <h2 className={`${isPWA ? 'fw-500 fs-15' : 'fw-600 fs-16 c-neutral-900 pt-2'}`}>{title}</h2>
            <p className={`${isPWA ? 'fs-13' : 'fs-14'} ${statusCode === 'ESCALATION' || statusCode === 'ESCALATED' ? 'c-red' : ''} ${statusCode === 'CLOSED' ? 'c-green' : ''} pt-1`}>{status}</p>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

const CaseDetails = props => {
  const { caseInfoHeader, caseInfo, index, toggleText, activeIndex, isPWA } = props
  return (
    <React.Fragment>
      <section className={`bg-white  ${isPWA ? 'p-4 border-bottom-grey' : 'px-8 pt-6'} flex flex-column`}>
        <div className={`flex flex-top ${isPWA ? '' : 'pb-1'}`}>
          <div className="flex-1">
            <h2 className={`${isPWA ? 'fs-15 fs-400' : 'fs-13 fw-600'}`}>{caseInfoHeader}</h2>
            <p className={`${index === activeIndex ? 'max-height-500' : ''} ${isPWA ? 'pt-1 fs-13' : 'pt-1 fs-13'} c-grey-40 read-more-less`}>{index === activeIndex ? caseInfo : caseInfo.substring(0, 100)}
              {caseInfo.length > (50) && <span className="read-handle c-pointer c-blue pl-1 pb-1" onClick={toggleText(index)}>{index !== activeIndex && '...Read More'}</span>}
            </p>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

const CaseDefaultReply = props => {
  const { defaultMessage, index, activeIndex, isPWA } = props
  return (
    <React.Fragment>
      <section className={`bg-white  ${isPWA ? 'p-4  border-bottom-grey' : 'px-8'} flex flex-column`}>
        <div className="flex flex-top">
          <div className={`flex flex-middle ${isPWA ? '' : 'pb-1'}`}>
            <p className={`${index === activeIndex ? 'max-height-500' : ''} fs-15 ${isPWA ? '' : 'pt-6'} read-more-less`}>{defaultMessage}
            </p>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

const onHelpBtnHandleClick = (e, tripId, callId, setComplaintToggle,
  setCallBackType, setHeader, setModalContent, setCallId, setDisableBg, isPWA, setLoader,
  action) => {
  if (action.toLowerCase() === 'i need urgent help') {
    fireClevertapEvent('I_need_urgent_help_clicked', { trip_id: tripId })
  } else {
    fireClevertapEvent('my_issue_is_not_resolved_clicked', { trip_id: tripId })
  }
  setLoader(true)
  setCallId(callId)
  httpAxios(CASE_HISTORY_MODAL_DETAIL + tripId, POST_CALL, {
    callId
  })
    .then(resp => {
      setComplaintToggle(true)
      if (isPWA) {
        setDisableBg(true)
      }
      setLoader(false)
      setCallBackType(resp.data.type)
      setHeader(resp.data.header)
      setModalContent(resp.data.message)
    })
    .catch(() => {
      setComplaintToggle(false)
      setLoader(false)
      if (isPWA) {
        setDisableBg(false)
      }
    })
}

const CaseHistoryCard = props => {
  const { caseData, tripId, setRefetchCases, setDisableBg, isPWA } = props
  const [callBackType, setCallBackType] = useState('')
  const [complaintToggle, setComplaintToggle] = useState(false)
  const [header, setHeader] = useState('')
  const [modalContent, setModalContent] = useState('')
  const [callId, setCallId] = useState('')
  const [activeIndex, setActiveIndex] = useState('')
  const [expanderFlag, updateExpanderFlag] = useState(false)
  const [loader, setLoader] = useState(false)

  const toggleText = index => () => {
    if (!expanderFlag) {
      setActiveIndex(index)
    } else if (expanderFlag && index !== activeIndex) {
      setActiveIndex(index)
    } else {
      setActiveIndex(-1)
    }
    updateExpanderFlag(!expanderFlag)
  }

  return (
    <React.Fragment>
      <If condition={complaintToggle && isPWA}>
        <div className="modal-outer backdrop-modal">
          <RaiseComplaintAction
            header={header}
            modalContent={modalContent}
            complaintToggle={complaintToggle}
            type={callBackType}
            setComplaintToggle={setComplaintToggle}
            setRefetchCases={setRefetchCases}
            callId={callId}
            tripId={tripId}
            setHeader={setHeader}
            setModalContent={setModalContent}
            setCallBackType={setCallBackType}
            setDisableBg={setDisableBg}
            isPWA={isPWA}
          />
        </div>
        <Else />
        <If condition={complaintToggle}>
          <RaiseComplaintActionDesktop
            header={header}
            modalContent={modalContent}
            complaintToggle={complaintToggle}
            type={callBackType}
            setComplaintToggle={setComplaintToggle}
            setRefetchCases={setRefetchCases}
            callId={callId}
            tripId={tripId}
            setHeader={setHeader}
            setModalContent={setModalContent}
            setCallBackType={setCallBackType}
            setDisableBg={setDisableBg}
            isPWA={isPWA}
          />
        </If>
      </If>
      <If condition={loader}>
        <PageLoader className={`${isPWA ? '' : 'modal-loader'}`} title="Please wait" message="While we are processing." />
        <Else />
        {
          caseData &&
          caseData.map((data, index) => {
            return (
              <div key={data.callId + Math.random()} className={`bg-white ${isPWA ? '' : 'border-bottom-grey pt-2'}`}>
                <CaseInfo
                  title={data.supportMenu}
                  status={data.caseStatusInfo}
                  isPWA={isPWA}
                  statusCode={data.caseStatusCode}
                />
                {data.defaultMsg && (
                  <CaseDefaultReply
                    defaultMessage={data.defaultMsg}
                    toggleText={toggleText}
                    index={`${index}_default`}
                    activeIndex={activeIndex}
                    isPWA={isPWA}
                  />
                )}
                {data.details && (
                  <CaseDetails
                    caseInfoHeader={data.details.infoHeader}
                    caseInfo={data.details.infoMsg}
                    index={index}
                    toggleText={toggleText}
                    activeIndex={activeIndex}
                    isPWA={isPWA}
                  />
                )}

                {data.resolution && (
                  <RowItem
                    isFlexStart={true}
                    isLowerLabelMin={true}
                    isPWA={isPWA}
                    label={data.resolution.header}
                    value={formatDateTime(new Date(data.resolution.dateTime))}
                    noBorder={!isPWA}
                    extraPadding={!isPWA}
                  />
                )}
                {data.supportMode && (
                  <RowItem
                    isLowerLabelMin={true}
                    isFlexStart={true}
                    isPWA={isPWA}
                    label="Support Mode"
                    value={data.supportMode}
                    noBorder={!isPWA}
                    extraPadding={!isPWA}
                    extraSpacing={!isPWA}
                  />
                )}
                <div className="mb-5">
                  {data.action && (
                    <div className={`${!isPWA && 'px-8'} p-4 ta-c mb-5`}>
                      <If condition={isPWA}>
                        <Button
                          full={true}
                          outline={true}
                          size="lg"
                          type="secondary"
                          className="tt-sentence fs-16 amr-10 w-100p h-10"
                          onClick={e => {
                            onHelpBtnHandleClick(
                              e,
                              tripId,
                              data.callId,
                              setComplaintToggle,
                              setCallBackType,
                              setHeader,
                              setModalContent,
                              setCallId,
                              setDisableBg,
                              isPWA,
                              setLoader,
                              data.action
                            )
                          }}
                        >
                          {data.action}
                        </Button>
                        <Else />
                        <button
                          type="submit"
                          className="tt-sentence case-btn fs-14 fw-500 amr-10 w-100p h-10 c-pointer"
                          onClick={e => {
                            onHelpBtnHandleClick(
                              e,
                              tripId,
                              data.callId,
                              setComplaintToggle,
                              setCallBackType,
                              setHeader,
                              setModalContent,
                              setCallId,
                              setDisableBg,
                              isPWA,
                              setLoader,
                              data.action
                            )
                          }}
                        >
                          {data.action}
                        </button>
                      </If>
                    </div>
                  )}
                </div>
              </div>
            )
          })
        }
      </If>

    </React.Fragment>
  )
}

export default CaseHistoryCard
